export var getCourseStatisticData = function (state) { return state.courseStatistic.data; };
